import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all targets
export const getTargets = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/targets`);
    return response.data;
  } catch (error) {
    console.error("Error fetching targets:", error.response?.data || error);
    throw error;
  }
};

// GET a single target by id
export const getTargetById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/targets/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching target:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new target
export const createTarget = async (targetData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/targets`, targetData);
    return response.data;
  } catch (error) {
    console.error("Error creating target:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing target
export const updateTarget = async (id, targetData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/targets/${id}`, targetData);
    return response.data;
  } catch (error) {
    console.error("Error updating target:", error.response?.data || error);
    throw error;
  }
};

// DELETE a target
export const deleteTarget = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/targets/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting target:", error.response?.data || error);
    throw error;
  }
};
